import api from './api';
import { CallReportResponse } from '../types';

export interface CallReportFilters {
  search?: string;
  called_by?: number;
  call_status_id?: number;
  call_outcome?: string;
  date_from?: string;
  date_to?: string;
  page?: number;
  per_page?: number;
}

const toParams = (filters?: CallReportFilters): URLSearchParams => {
  const params = new URLSearchParams();
  if (!filters) return params;
  Object.entries(filters).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') {
      params.append(k, String(v));
    }
  });
  return params;
};

const getReport = async (path: string, filters?: CallReportFilters): Promise<CallReportResponse> => {
  const params = toParams(filters);
  const response = await api.get(`${path}?${params.toString()}`);
  return response.data;
};

export const callReportService = {
  getLeadCalls: (filters?: CallReportFilters): Promise<CallReportResponse> =>
    getReport('/api/reports/lead-calls', filters),
  getTenderCalls: (filters?: CallReportFilters): Promise<CallReportResponse> =>
    getReport('/api/reports/tender-calls', filters),
  getCustomerCalls: (filters?: CallReportFilters): Promise<CallReportResponse> =>
    getReport('/api/reports/customer-calls', filters),
};

